module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/ucr-donut/ucr-donut.component.css
// module id = ./src/app/Screens/ucr-donut/ucr-donut.component.css
// module chunks = main